import { render, staticRenderFns } from "./PatientReferral.vue?vue&type=template&id=54a470a2&"
import script from "./PatientReferral.vue?vue&type=script&lang=js&"
export * from "./PatientReferral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports